export const messageHistoryCopyFr = {
    title: "Historique des messages",
    noMessages: "Aucun message trouvé",
    viewMessages: "Voir les messages",
    to: "À :",
    from: "De :",
    subject: "Objet :",
    statusClicked: "Cliqué",
    statusRead: "Lu",
    statusReadAt: "à",
    statusDelivered: "Remis",
    statusSent: "Envoyé",
    statusPending: "En attente",
    channelEmail: "E-mail",
    channelSms: "SMS",
    retentionNotice: "Les messages ne sont conservés que pendant 30 jours",
};
